import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { Check, IsOpen, Times, ArrowDown } from '../../../components/Icon';
import { Modal, ModalControls } from '../../../components/Modal';
import { FormField } from '../../../components/FormFields';
import Dropdown from '../../../components/Dropdown/ReactDropdown';
import { Loader } from '../../../components/Loader';
import { ChangeLocationModal } from './ChangeLocationModal';
import { WithCompany } from '../../Companies/components/WithCompany';
import { CompanyLabel } from '../../Companies/components/CompanyLabel';
import { COLOR_SECONDARY_1 } from '../../../vars';
import { setVehicleProperties, setVehicleProperty, deleteVehicleProperty, fetchVehicle } from '../actions';
import { fetchAddress } from '../../Address/actions';
import { fetchCompany, updateAddress } from '../../Companies/actions';
import { selectCompany, selectCountries } from '../../Companies/selectors';
import { selectWorks } from '../../Api/selectors';
import { getPropByName } from '../../../utils/props';
import { IDW_ADDRESSES } from '../../Address/constants';
import { REQUEST_VEHICLE_PROPERTIES, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import _ from 'lodash';

import cn from 'classnames';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import styles from './cardHooicardproducts.module.css';

const Container = styled.div`
  .started {
    margin: 12px 0;
    font-weight: 600;
  }
  .sub-title {
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
    width: 100%;
    margin: 12px 0 0;
  }
  .address {
    border: 1px solid #ddd;
    border-radius: 12px;
    padding: 12px;
    margin: 12px;
    .name {
      font-weight: 600;
    }

    &.selected {
      border: 2px solid ${COLOR_SECONDARY_1};
    }
  }
  .dropdown-block {
    min-height: 300px;
  }

  .dropdown {
    min-width: 250px;
  }
`;
let date_done = new Date().toISOString();

const STATE = {
  init: false,
  takeout: false,
  isOpen: false,
  values: null,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleHooicardproductsComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  reset() {
    this.setState({
      init: false,
      takeout: false,
    });
  }

  render() {
    if (this.props.work) return <Loader />;
    const vehicle = this.props.vehicle;
    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          <HBox>
            <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.Productfactuur')}</h2>
            {window.innerWidth <= 768 && (
              <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                <IsOpen />
              </div>
            )}
          </HBox>
          {(this.state.isOpen || window.innerWidth > 768) && (
            <>
              {vehicle.HOOI_product_invoice_processed == '1' ? (
                <Button className={styles.buttonPrimary} primary onClick={() => this.setState({ takeout: true })}>
                  Productfactuur afgerond
                </Button>
              ) : (
                <div className={styles.containerButton}>
                <Button className={styles.button} onClick={() => this.setState({ takeout: true })}>Productfactuur afronden</Button>
                </div>
              )}

              {this.renderModal()}
            </>
          )}
        </Container>
      </Card>
    );
  }

  renderModal() {
    if (this.state.takeout) return this.renderTakeoutModal();
    if (!this.state.init) return null;
  }

  renderTakeoutModal() {
    const vehicle = this.props.vehicle;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title="Productfactuur afgerond?">
        <div className={styles.containerButton}>
          {vehicle.HOOI_product_invoice_processed != '1' ? (
            <VBox>
              {['1'].map(n => (
                <Button className={styles.button} onClick={() => this.props.takeout(n, this.reset.bind(this))} key={n}>
                  {this.lbl(`Productfactuur afronden`)}
                </Button>
              ))}
            </VBox>
          ) : (
            <VBox>
              {['0'].map(n => (
                <Button className={styles.button} onClick={() => this.props.takeout(n, this.reset.bind(this))} key={n}>
                  {this.lbl(`Ongedaan maken`)}
                </Button>
              ))}
            </VBox>
          )}
        </div>
      </ModalComponent>
    );
  }
}

VehicleHooicardproductsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicle?.id}`, REQUEST_VEHICLE_PROPERTY_UPDATE]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    takeout(id, callback) {
      let todaydate = new Date().toISOString();
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'HOOI_product_invoice_processed', id, callback));

      dispatch(setVehicleProperty(ownProps.vehicle.id, 'HOOI_product_invoice_processed_date', todaydate, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleHooicardproducts = compose(withConnect, withRouter)(VehicleHooicardproductsComp);
